import { CRUDPage } from "./AdminServices";
import { TextInput, TextArea, Toggle } from "./ui";

export default function AdminMaterials() {
  return (
    <CRUDPage
      endpoint="materials"
      title="Malzemeler"
      Form={MaterialForm}
      columns={[
        { k: "name", l: "İsim" },
        { k: "key", l: "Anahtar" },
        { k: "spec", l: "Özet" },
      ]}
      emptyModel={{ key: "", name: "", desc: "", spec: "", rate_lo: 15, rate_hi: 30, in_stock: true, order: 0, active: true }}
      testid="materials"
    />
  );
}

function MaterialForm({ v, set }) {
  const stockLabel = v.in_stock ? "Stokta Var" : "Stokta Yok";
  const visibilityLabel = v.active ? "Yayında" : "Gizli";

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <TextInput label="Anahtar (PLA, PETG…)" value={v.key || ""} onChange={(e) => set("key", e.target.value.toUpperCase())} />
        <TextInput label="İsim (varsayılan / TR)" value={v.name || ""} onChange={(e) => set("name", e.target.value)} />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <TextInput label="İsim TR (üzerine yazar, opsiyonel)" value={v.title_tr || ""} onChange={(e) => set("title_tr", e.target.value)} />
        <TextInput label="İsim EN" value={v.title_en || ""} onChange={(e) => set("title_en", e.target.value)} />
      </div>
      <TextArea label="Açıklama (varsayılan / TR)" rows={3} value={v.desc || ""} onChange={(e) => set("desc", e.target.value)} />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <TextArea label="Açıklama TR (opsiyonel)" rows={3} value={v.description_tr || ""} onChange={(e) => set("description_tr", e.target.value)} />
        <TextArea label="Açıklama EN" rows={3} value={v.description_en || ""} onChange={(e) => set("description_en", e.target.value)} />
      </div>
      <TextInput label="Teknik Özet" value={v.spec || ""} onChange={(e) => set("spec", e.target.value)} />
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <TextInput label="Fiyat Min (₺/cm³)" type="number" step="0.5" value={v.rate_lo ?? 0} onChange={(e) => set("rate_lo", parseFloat(e.target.value) || 0)} />
        <TextInput label="Fiyat Max (₺/cm³)" type="number" step="0.5" value={v.rate_hi ?? 0} onChange={(e) => set("rate_hi", parseFloat(e.target.value) || 0)} />
        <TextInput label="Sıra" type="number" value={v.order ?? 0} onChange={(e) => set("order", parseInt(e.target.value) || 0)} />
        <div className="flex flex-col gap-2 justify-end pb-1">
          <Toggle checked={!!v.in_stock} onChange={(x) => set("in_stock", x)} label={stockLabel} />
          <Toggle checked={!!v.active} onChange={(x) => set("active", x)} label={visibilityLabel} />
        </div>
      </div>
      <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-zinc-500">
        `Stokta Yok` sitede karti gizlemez. Yalnizca stok rozeti degisir. `Gizli` yaparsan malzeme siteden tamamen kalkar.
      </p>
    </div>
  );
}
